export default __webpack_public_path__ + "static/img-home-vft-fa30ed15decb5895f7376fe905a9dc60.jpg";